module.exports = __webpack_public_path__ + "img/LIGHTING 2 BW.b4ab9ae.svg";